// configurable-globals.ts
import { BROWSER } from "esm-env";
export const defaultWindow = /* #__PURE__ */ BROWSER ? window : undefined;
export const defaultDocument = /* #__PURE__ */ BROWSER ? window.document : undefined;
export const defaultNavigator = /* #__PURE__ */ BROWSER ? window.navigator : undefined;
export const defaultLocation = /* #__PURE__ */ BROWSER ? window.location : undefined;
